// extracted by mini-css-extract-plugin
module.exports = {"FooterWrapper":"Footer_FooterWrapper__2MJkD","FooterText":"Footer_FooterText__FdB-4"};